module.exports = __webpack_public_path__ + "img/downloading-ditto.148a3a8f.gif";